module.exports = __webpack_public_path__ + "static/mortgage-award-2020-cf9ce3953ff89bf623964beb840831ed.png";